/* Get Joy — shared plan math (Oct 2026).
   One place for "first box / then / per day" so the Auto-Ship page, Compare page and the
   content module can't disagree with the PDPs. The rules are lifted from the live PDPs:
   FDR  = assets/fdr-buybox.js derived()  (cup table, 12 cups per 32 oz bag, 30-day month, 10% plan price, 44.46% first-order function)
   Fresh = assets/gjf-fresh.js calc()/prices() (MER on the tier weight, kcal/g per variant, packs clamped, cadence pick, Skio plan prices)
   Config (live prices) comes from snippets/gjz-plan-config.liquid → <script id="gjz-plan-config">.
   Any change to the PDP math must be mirrored here (and in snippets/gjz-plan-calc.liquid). */
(function () {
  'use strict';
  if (window.GJZPlan) return;
  var el = document.getElementById('gjz-plan-config');
  var C = {};
  try { C = el ? JSON.parse(el.textContent) : {}; } catch (e) { C = {}; }

  var FIRST = 4446; // checkout's first-order function, in basis points (≈ 50% off list)
  var firstOf = function (c) { return c - Math.floor(c * FIRST / 10000); }; // cents → cents

  /* ---------- Freeze Dried Raw ---------- */
  var CUP_TABLE = [[5, .5], [10, 1], [15, 1.25], [30, 2.25], [50, 3.75], [75, 5], [100, 6]];
  function cupsFor(w) {
    if (w <= 5) return .5;
    if (w >= 100) return 6;
    for (var i = 1; i < CUP_TABLE.length; i++) {
      if (w <= CUP_TABLE[i][0]) {
        var w0 = CUP_TABLE[i - 1][0], c0 = CUP_TABLE[i - 1][1], w1 = CUP_TABLE[i][0], c1 = CUP_TABLE[i][1];
        return c0 + (w - w0) / (w1 - w0) * (c1 - c0);
      }
    }
    return 6;
  }
  var BAG_CUPS = 12;
  function fdr(lb, o) {
    o = o || {};
    var f = C.fdr || {}, v = f[o.protein || 'beef'] || f.beef || {};
    var full = v.price || 4994; // cents
    var weeks = o.weeks || 4, days = weeks * 7;
    var topper = o.mode === 'topper';
    var cups = cupsFor(lb);
    var topCupN = lb < 25 ? .25 : lb < 50 ? 1 / 3 : .5;
    var daily = topper ? topCupN : cups;
    var target = days === 28 ? 30 : days;
    var bags = topper ? Math.max(1, Math.ceil(topCupN * days / BAG_CUPS)) : Math.max(1, Math.ceil(cups * target / BAG_CUPS - 1e-9));
    var sp = Math.round(full * 0.9);
    var renew = bags * sp, first = bags * firstOf(sp);
    return {
      product: 'fdr', lb: lb, weeks: weeks, days: days, bags: bags, cups: cups, daily: daily,
      coverDays: Math.floor(bags * BAG_CUPS / daily),
      full: bags * full, first: first, renew: renew,
      perDay: Math.round(renew / days), firstPerDay: Math.round(first / days)
    };
  }

  /* ---------- Fresh Meals ---------- */
  var GPL = 453.592;
  function fresh(lb, o) {
    o = o || {};
    var F = C.fresh || {}, tiers = F.tiers || [];
    if (!tiers.length) return null;
    var t = tiers[tiers.length - 1];
    for (var i = 0; i < tiers.length; i++) if (lb < tiers[i].max) { t = tiers[i]; break; }
    var R = (F.recipes || {})[o.recipe || F.defaultRecipe] || {};
    var v = (R.v || {})[t.tok] || {};
    var packLbs = /half/i.test(t.tok) ? 0.5 : 1;
    var M = F.mer || { a: 1.7, n: .85, act: 1, mod: .84 };
    var mer = 70 * Math.pow((t.w || 17) / 2.2, 0.75) * M.a * M.n * M.act * M.mod;
    var dp = (mer / (v.kcal || 1.474) / GPL) / packLbs * (o.mode === 'topper' ? 0.5 : 1);
    var maxP = packLbs >= 1 ? F.pmaxOne : F.pmaxHalf, minP = F.pmin;
    var avail = (F.cadences || [1, 2, 3, 5]).filter(function (w) { return v.plans && v.plans[String(w)]; });
    if (!avail.length) avail = [2];
    var packs = function (wk) { return Math.ceil(dp * wk * 7); };
    var best = avail[0], p2 = packs(2);
    if (avail.indexOf(2) > -1 && p2 >= minP && p2 <= maxP) best = 2;
    else if (minP > p2) {
      var tg = minP / (dp * 7);
      best = avail.slice().sort(function (a, b) { return (Math.abs(a - tg) - Math.abs(b - tg)) || (a - b); })[0];
    } else {
      var c2 = avail.filter(function (wk) { return wk < 2 && packs(wk) <= maxP; });
      best = c2.length ? c2[c2.length - 1] : avail[0];
    }
    var n = Math.max(minP, Math.min(maxP, packs(best)));
    var renewU = (v.plans && v.plans[String(best)]) || v.price || 0;
    var renew = renewU * n, first = firstOf(renewU) * n, days = best * 7;
    return {
      product: 'fresh', lb: lb, weeks: best, days: days, packs: n, packLbs: packLbs,
      full: (v.price || 0) * n, first: first, renew: renew,
      perDay: Math.round(renew / days), firstPerDay: Math.round(first / days)
    };
  }

  var money = function (c) { return '$' + (Math.round(c) / 100).toFixed(2); };
  var cupStr = function (n) {
    var r = Math.round(n * 4) / 4, i = Math.floor(r), f = +(r - i).toFixed(2);
    var fr = { 0: '', 0.25: '¼', 0.5: '½', 0.75: '¾' }[f] || '';
    return ((i || !fr) ? i : '') + fr || '¼';
  };
  var every = function (w) { return w === 1 ? 'every week' : 'every ' + w + ' weeks'; };

  window.GJZPlan = { fdr: fdr, fresh: fresh, money: money, cupStr: cupStr, every: every, config: C };

  /* ---------- tiny binder: [data-gjzp] elements update when a weight picker changes ----------
     <div data-gjzp-scope> … <button data-gjzp-lb="30" aria-pressed="true"> … <span data-gjzp="fdr.first"></span> */
  function fill(scope, lb) {
    var r = { fdr: fdr(lb), fresh: fresh(lb) };
    Array.prototype.forEach.call(scope.querySelectorAll('[data-gjzp]'), function (n) {
      var k = n.getAttribute('data-gjzp').split('.'), d = r[k[0]];
      if (!d) return;
      var val;
      switch (k[1]) {
        case 'first': case 'renew': case 'perDay': case 'full': val = money(d[k[1]]); break;
        case 'every': val = every(d.weeks); break;
        case 'cups': val = cupStr(d.cups); break;
        case 'coverDays': val = String(d.coverDays); break;
        case 'lb': val = String(lb); break;
        default: val = d[k[1]] != null ? String(d[k[1]]) : '';
      }
      if (n.textContent !== val) n.textContent = val;
    });
  }
  window.GJZPlan.fill = fill;
  function init(scope) {
    var btns = scope.querySelectorAll('[data-gjzp-lb]');
    var other = scope.querySelector('[data-gjzp-other]');
    var input = scope.querySelector('[data-gjzp-input]');
    var ev = scope.getAttribute('data-gjzp-event') || 'plan_weight';
    function pick(lb, src) {
      lb = Math.max(5, Math.min(120, Math.round(+lb || 30)));
      Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-gjzp-lb') === lb && src !== 'other')); });
      if (other) other.setAttribute('aria-pressed', String(src === 'other'));
      fill(scope, lb);
      try { (window.dataLayer = window.dataLayer || []).push({ event: ev, lb: lb }); } catch (e) {}
    }
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () { if (input) input.parentNode.hidden = true; pick(b.getAttribute('data-gjzp-lb')); });
    });
    if (other && input) {
      other.addEventListener('click', function () { input.parentNode.hidden = false; input.focus(); other.setAttribute('aria-pressed', 'true'); Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-pressed', 'false'); }); });
      input.addEventListener('input', function () { var v = +input.value; if (v >= 5 && v <= 120) pick(v, 'other'); });
    }
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-gjzp-scope]'), init);
})();
